import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker.worker_profit.table_header.';
export const workerProfitTableHeader = [
    {
        title: t(`${lc}worker_name`),
        value: 'formattedWorkerName',
        width: 190,
        key: 'workerName',
        sortable: true,
        fixed: true,
        align: 'center',
    },
    {
        title: t(`${lc}hub_name`),
        value: 'formattedHubName',
        width: 190,
        align: 'center',
    },
    {
        title: t(`${lc}adjustment_date`),
        value: 'formattedAdjustmentDate',
        width: 110,
        key: 'adjustmentDate',
        sortable: true,
        align: 'center',
    },
    {
        title: t(`${lc}employee_type`),
        value: 'formattedEmployeeType',
        width: 170,
        align: 'center',
    },
    {
        title: t(`${lc}salary_type`),
        value: 'formattedSalaryType',
        width: 150,
        align: 'center',
    },
    // 사번
    {
        title: t(`${lc}hub_employee_number`),
        value: 'formattedHubEmployeeNumber',
        width: 100,
        align: 'center',
    },
    {
        title: t(`${lc}worker_code`),
        value: 'formattedWorkerCode',
        width: 100,
        align: 'center',
    },
    {
        title: t(`${lc}worker_baromoney_closing_amount`),
        value: 'formattedWorkerBaromoneyClosingAmount',
        align: 'center',
        width: 170,
    },
    {
        title: t(`${lc}order_finish_count`),
        value: 'formattedOrderFinishCount',
        align: 'center',
        width: 90,
    },
    {
        title: t(`${lc}delivery_adjust_amount`),
        value: 'formattedDeliveryAdjustAmount',
        align: 'center',
        width: 150,
    },
    {
        title: t(`${lc}delivery_fee`),
        value: 'formattedDeliveryFee',
        align: 'center',
        width: 150,
    },
    {
        title: t(`${lc}worker_profit`),
        value: 'formattedWorkerProfit',
        align: 'center',
        width: 150,
    },
    // 원천세
    {
        title: t(`${lc}worker_withholding_tax`),
        value: 'formattedWorkerWithholdingTax',
        align: 'center',
        width: 140,
    },
    {
        title: t(`${lc}baromoney_adjust_amount_sum`),
        value: 'formattedBaromoneyAdjustAmountSum',
        align: 'center',
        width: 150,
    },
    {
        title: t(`${lc}pay_cash_amount`),
        value: 'formattedPayCashAmount',
        align: 'center',
        width: 140,
    },
    {
        title: t(`${lc}company_deposit_amount`),
        value: 'formattedCompanyDepositAmount',
        align: 'center',
        width: 140,
    },
];
